import type { ManagedZoneRef, Space } from "@gettactic/api";

/**
 * The `shape_id`s of the regions on a floor that the person manages at
 * `officeId`. `managedZones` is already expanded to each zone's subtree, so
 * a region counts when its effective zone (its own tag, else the nearest
 * tagged ancestor) is in the list.
 */
export const getManagedRegionShapeIds = (
  spaces: Pick<Space, "shape_id" | "effective_zone_id">[],
  officeId: string,
  managedZones: ManagedZoneRef[]
): string[] => {
  const managedZoneIds = new Set(
    managedZones
      .filter((managed) => managed.office_id === officeId)
      .map((managed) => managed.zone_id)
  );
  return spaces
    .filter(
      (space) =>
        !!space.effective_zone_id && managedZoneIds.has(space.effective_zone_id)
    )
    .map((space) => space.shape_id);
};
